(function () {
  "use strict";

  var config = window.CMT_CONFIG || {};
  var assets = config.assets || {};
  var variants = config.variants || {
    onepc: "67653116297401",
    twopcs: "67653116330169"
  };
  var store = config.store || window.location.origin;
  var selected = "twopcs";
  var name = "CutMaster Electric Drill Plate Cutter";
  var bundles = [
    {key: "onepc", image: assets.onepc, description: "1pc / 1 Set", price: "$32.99", was: "$65.99", best: false},
    {key: "twopcs", image: assets.twopcs, description: "2pcs — $29.99 each", price: "$59.99", was: "$119.99", best: true}
  ];

  function paymentImages() {
    return ["paypal", "visa", "mastercard", "amex", "discover", "applepay", "gpay"]
      .map(function (key) {
        return assets[key] ? '<img src="' + assets[key] + '" alt="" loading="lazy">' : "";
      }).join("");
  }

  function card(bundle) {
    return '<label class="pg-card' + (bundle.key === selected ? ' pg-selected' : '') + '" data-key="' + bundle.key + '">' +
      (bundle.best ? '<span class="pg-badge-best">Best Seller</span>' : '') +
      '<span class="pg-radio" aria-hidden="true"></span>' +
      '<img class="pg-img" src="' + bundle.image + '" alt="' + bundle.description + '" loading="lazy">' +
      '<div class="pg-info"><div class="pg-name">' + name + '</div>' +
      '<div class="pg-desc">' + bundle.description + '</div>' +
      '<div class="pg-price"><span class="pg-now">' + bundle.price + '</span><span class="pg-was">' + bundle.was + '</span></div>' +
      '<span class="pg-off">50% OFF</span></div></label>';
  }

  function markup() {
    return '<div class="pg-head"><div class="pg-model">New &amp; Improved 2026 Model</div>' +
      '<div class="pg-social"><span class="pg-stars">★★★★★</span><span>6,000+ Happy Customers</span></div></div>' +
      '<h2 class="pg-title">Choose Your Bundles</h2>' +
      '<div class="pg-cards">' + bundles.map(card).join("") + '</div>' +
      '<a href="#" class="pg-atc" id="pgAtc">Add to cart</a>' +
      '<div class="pg-pay-title"><span>SECURE PAYMENT GUARANTEED</span></div>' +
      '<div class="pg-pay">' + paymentImages() + '</div>' +
      '<div class="pg-guar"><img class="pg-guar-badge" src="' + assets.guarantee + '" alt="90 Day Money Back Guarantee" loading="lazy">' +
      '<div><div class="pg-guar-h">90 Day Money Back Guarantee</div>' +
      '<p class="pg-guar-t">Ensuring that our customers are 100% happy with every product they purchase from us is critically important to us. If you are not 100% satisfied with your purchase, you can return it for a full refund within 90 days of purchase.</p></div></div>';
  }

  function trackingUrl(destination) {
    var allowed = /^(gclid|gbraid|wbraid|fbclid|msclkid|utm_[a-z0-9_]+)$/i;
    var target = new URL(destination, window.location.origin);
    new URLSearchParams(window.location.search).forEach(function (value, key) {
      if (!allowed.test(key)) return;
      target.searchParams.set(key, value);
      target.searchParams.set("attributes[" + key + "]", value);
    });
    return target.toString();
  }

  function build() {
    var wrapper = document.createElement("section");
    wrapper.className = "pg-bundles";
    wrapper.id = "pgBundles";
    wrapper.innerHTML = markup();
    wrapper.addEventListener("click", function (event) {
      var cardElement = event.target.closest(".pg-card");
      if (cardElement) {
        event.preventDefault();
        selected = cardElement.getAttribute("data-key");
        wrapper.querySelectorAll(".pg-card").forEach(function (item) {
          item.classList.toggle("pg-selected", item === cardElement);
        });
      }
    });
    wrapper.querySelector("#pgAtc").addEventListener("click", function (event) {
      event.preventDefault();
      var variant = variants[selected];
      if (!variant) return;
      var destination = trackingUrl(store + "/cart/" + variant + ":1");
      if (window.PrimeGradeFunnelAds) window.PrimeGradeFunnelAds.beginCheckout(destination);
      else window.location.href = destination;
    });
    return wrapper;
  }

  function findFaqHeading() {
    return Array.prototype.find.call(document.querySelectorAll("h1,h2,h3,h4,div,p,span"), function (element) {
      var text = (element.textContent || "").trim();
      return /frequently asked questions/i.test(text) && text.length < 48 && element.children.length <= 1;
    });
  }

  function insert() {
    if (document.getElementById("pgBundles")) return true;
    var heading = findFaqHeading();
    if (!heading || !heading.parentElement) return false;
    heading.parentElement.insertBefore(build(), heading);
    return true;
  }

  function rewireCallsToAction() {
    if (!document.getElementById("pgBundles")) return;
    document.querySelectorAll('a[href="#pgBundles"], .cmt-product-sticky').forEach(function (link) {
      link.setAttribute("href", "#pgBundles");
      if (link.__cmtCta) return;
      link.__cmtCta = true;
      link.addEventListener("click", function (event) {
        event.preventDefault();
        document.getElementById("pgBundles").scrollIntoView({behavior: "smooth", block: "start"});
      });
    });
  }

  function syncSticky() {
    var bundle = document.getElementById("pgBundles");
    var sticky = document.querySelector(".cmt-product-sticky");
    if (!bundle || !sticky) return;
    var rect = bundle.getBoundingClientRect();
    var viewport = window.innerHeight || document.documentElement.clientHeight;
    sticky.style.display = rect.top < viewport * 0.9 && rect.bottom > viewport * 0.1 ? "none" : "block";
  }

  function addStyles() {
    if (document.getElementById("cmtBundleStyles")) return;
    var style = document.createElement("style");
    style.id = "cmtBundleStyles";
    style.textContent =
      ".pg-bundles{max-width:680px;margin:28px auto 8px;padding:0 16px;font-family:inherit;box-sizing:border-box;scroll-margin-top:16px}" +
      ".pg-bundles *{box-sizing:border-box}" +
      ".pg-head{text-align:center;margin:0 0 18px}.pg-model{font-size:22px;font-weight:800;color:#111;margin:0 0 6px}" +
      ".pg-social{display:flex;align-items:center;justify-content:center;gap:10px;font-size:15px;color:#6b7280;font-weight:600}.pg-stars{color:#f5b301;font-size:18px;letter-spacing:1px}" +
      ".pg-title{font-size:26px;font-weight:800;text-align:left;margin:0 0 16px;color:#111}.pg-title:after{content:'';display:block;height:1px;background:#e5e7eb;margin-top:10px}" +
      ".pg-card{position:relative;display:flex;align-items:center;gap:12px;border:1px solid #e3e6ea;border-radius:10px;padding:14px 14px 14px 44px;margin-bottom:14px;cursor:pointer;transition:border-color .15s,background .15s;background:#fff}" +
      ".pg-card.pg-selected{border-color:#2f6fed;background:#f3f7ff;box-shadow:0 0 0 1px #2f6fed inset}.pg-radio{position:absolute;left:14px;top:50%;transform:translateY(-50%);width:20px;height:20px;border:2px solid #c3c9d2;border-radius:50%}" +
      ".pg-card.pg-selected .pg-radio{border-color:#1f8f46}.pg-card.pg-selected .pg-radio:after{content:'';position:absolute;left:3px;top:3px;width:10px;height:10px;border-radius:50%;background:#1f8f46}" +
      ".pg-img{width:92px;height:92px;object-fit:contain;flex:none;background:#fff}.pg-info{flex:1;min-width:0}.pg-name{font-weight:700;font-size:15px;line-height:1.25;color:#111}" +
      ".pg-desc{font-size:13px;color:#6b7280;margin:3px 0 6px}.pg-price{display:flex;align-items:baseline;gap:8px}.pg-now{color:#e23744;font-weight:800;font-size:19px}.pg-was{color:#9ca3af;text-decoration:line-through;font-size:14px}" +
      ".pg-off{display:inline-block;margin-top:6px;background:#fde8ea;color:#e23744;font-weight:700;font-size:12px;padding:3px 10px;border-radius:999px}.pg-badge-best{position:absolute;top:-10px;left:36px;background:#c0392b;color:#fff;font-size:12px;font-weight:700;padding:3px 10px;border-radius:5px}" +
      ".pg-atc{display:block;width:100%;text-align:center;background:#00af57;color:#fff!important;font-weight:700;font-size:18px;padding:15px;border:0;border-radius:6px;cursor:pointer;text-decoration:none!important;margin:4px 0 16px}.pg-atc:hover{background:#049c4e}" +
      ".pg-pay-title{display:flex;align-items:center;gap:12px;color:#8a909a;font-size:12px;letter-spacing:.06em;margin:4px 0 12px}.pg-pay-title:before,.pg-pay-title:after{content:'';flex:1;height:1px;background:#e5e7eb}" +
      ".pg-pay{display:flex;flex-wrap:wrap;justify-content:center;gap:8px;margin-bottom:26px}.pg-pay img{height:30px;width:auto;border:1px solid #eef0f3;border-radius:6px;background:#fff;padding:2px}" +
      ".pg-guar{display:flex;align-items:flex-start;gap:16px;border-top:1px solid #eef0f3;padding-top:20px;margin-bottom:8px}.pg-guar-badge{width:96px;height:auto;flex:none}.pg-guar-h{font-size:20px;font-weight:800;color:#111;margin-bottom:6px}.pg-guar-t{font-size:14px;color:#4b5563;line-height:1.5;margin:0}" +
      "@media(max-width:520px){.pg-title{text-align:center}.pg-img{width:76px;height:76px}.pg-now{font-size:17px}.pg-guar-badge{width:72px}.pg-guar-h{font-size:17px}}";
    document.head.appendChild(style);
  }

  function start() {
    addStyles();
    insert();
    rewireCallsToAction();
    syncSticky();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
  window.addEventListener("scroll", syncSticky, {passive: true});
  window.addEventListener("resize", syncSticky, {passive: true});
})();
